// extracted by mini-css-extract-plugin
export var card = "_6o-0";
export var failedIcon = "_6o-4";
export var failedIconBadge = "_6o-3";
export var icon = "_6o-1";
export var successIcon = "_6o-2";